<template>
  <div>
    <h1 class="display-3">Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami</h1><br/>

    <div class="mb-3" v-for="zgrupowanie in powolania.zgrupowania" :key="zgrupowanie.id">
      <p class="display-4">{{zgrupowanie.name}}</p>
      <b-row>
        <b-col md="6">
          <p>
            W zgrupowaniu uczestniczyli:
            <ul><li class="mb-2" v-for="uczestnik in zgrupowanie.participants">{{uczestnik}}</li></ul>
          </p>
          <p>{{zgrupowanie.img.desc}}</p>
        </b-col>
        <b-col md="5">
          <b-img center fluid :src="zgrupowanie.img.url"/><br/>
        </b-col>
      </b-row>
    </div>

    <b-row class="mb-5">
      <b-col md="6">
        <span class="lead">Operacja „Ostra Brama”</span>
        <b-img center fluid src="/historia/powolanie_zgrupowan/operacja_ostra_brama.gif"/><br/>
      </b-col>
      <b-col md="6">
        <span class="lead">Plan ufortyfikowania miasta Wilna na dzień 6 lipca 1944</span>
        <b-img center fluid src="/historia/powolanie_zgrupowan/plan_miasta_wilna.jpg"/><br/>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6" order-md="1" order="2">
        <b-embed type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/ZzEmwwyCIVY"
          allowfullscreen
        ></b-embed>
      </b-col>
      <b-col md="6" order-md="2" order="1">
        <p class="lead">Drogi do "Ostrej Bramy" (fragment)</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import powolanie_zgrupowan from '@/models/historia/powolanie_zgrupowan'

export default {
  name: 'powolanie_zgrupowan',
  data: function(){
    return{
      powolania: powolanie_zgrupowan
    }
  },
  metaInfo:{
    title: 'Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami',
    meta:[
      {name: 'description', content: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"' },
      {name: 'og:url', content: 'http://akwilno.pl/historia/powolanie_zgrupowan' },
      {name: 'og:title', content: 'Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami' },
      {name: 'og:image', content: '/historia/powolanie_zgrupowan.jpg' },
      {name: 'og:description', content: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"' },
      {name: 'twitter:url', content: 'http://akwilno.pl/historia/powolanie_zgrupowan' },
      {name: 'twitter:title', content: 'Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami' },
      {name: 'witter:image', content: '/historia/powolanie_zgrupowan.jpg' },
      {name: 'twitter:description', content: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/historia/powolanie_zgrupowan.vue